export const messages = {
  en: {
    userDetailIntegralDetail: {
      id: 'ID',
      accountName: 'Account Name',
      accountId: 'Account ID',
      type: 'Type',
      transferOut: 'Transfer Out',
      transferIn: 'Transfer In',
      relatedAccount: 'Related Account',
      integralAmount: 'Integral Amount',
      objType: 'Object Type',
      merchant: 'Merchant',
      user: 'User',
      objId: 'Object ID',
      tel: 'Phone',
      orderNo: 'Order No',
      transactionTime: 'Transaction Time',
      remark: 'Remark'
    }
  },
  zh: {
    userDetailIntegralDetail: {
      id: '编号',
      accountName: '账户名称',
      accountId: '账户编号',
      type: '类型',
      transferOut: '转出',
      transferIn: '转入',
      relatedAccount: '关联账户',
      integralAmount: '积分数',
      objType: '对象类型',
      merchant: '商户',
      user: '用户',
      objId: '对象ID',
      tel: '手机号',
      orderNo: '交易单号',
      transactionTime: '交易时间',
      remark: '备注'
    }
  }
}